/**
 * Page for profile management
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { uiState } from 'react-redux-ui-state';

import Poll from 'components/Poll/Poll';
import ORContentHeader from 'components/ORContentHeader/ORContentHeader';
import ORContentArea from 'components/ORContentArea/ORContentArea';
import InviteUserCardForm from './InviteUserCardForm/InviteUserCardFormContainer';
import InviteUserCard from './InviteUserCard/InviteUserCardContainer';
import UserCardForm from './UserCardForm/UserCardFormContainer';
import LoadingPlaceHolder from '../../LoadingPlaceholder/LoadingPlaceholder';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  invites: PropTypes.arrayOf(PropTypes.object).isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  loaded: PropTypes.bool.isRequired,
  getUserInvitesState: PropTypes.func.isRequired,
  getUsersState: PropTypes.func.isRequired,
  getUsersPoll: PropTypes.func.isRequired,
  setUiState: PropTypes.func.isRequired,
  isLoadingUsers: PropTypes.bool.isRequired,
};

export function UnstyledUsersPage({
  classes,
  invites,
  users,
  loaded,
  getUserInvitesState,
  getUsersState,
  getUsersPoll,
  setUiState,
  isLoadingUsers,
}) {
  if (!loaded) {
    setUiState({ loaded: true });
    getUsersState();
    getUserInvitesState();
  }

  let spinner = null;

  if (isLoadingUsers) {
    spinner = <LoadingPlaceHolder />;
  }

  return (
    <React.Fragment>
      <Poll intervalInMS={15000} actionCreator={getUsersPoll} />
      <ORContentHeader hasDivider>Users & Permissions</ORContentHeader>
      <ORContentArea>
        <div className={classes.widgetsArea}>
          <InviteUserCardForm className={classes.cards} />
          {invites.map((invite) => (
            <InviteUserCard key={invite.email2invite} invite={invite} className={classes.cards} />
          ))}
          {users.map((user) => (
            <UserCardForm
              key={user.id}
              form={user.id} // Required for multiple forms in the same page
              user={{ ...user, role: user.roles[0] }}
              initialValues={{
                email: user.email,
                role: user.roles[0],
                deleteFlag: false,
                resetFlag: false,
              }}
              className={classes.cards}
            />
          ))}
          {spinner}
        </div>
      </ORContentArea>
    </React.Fragment>
  );
}

UnstyledUsersPage.propTypes = propTypes;

const styles = (theme) => ({
  widgetsArea: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '0px auto 8px auto',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  cards: {
    width: 'calc((100% - 16px) / 2)',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      margin: theme.spacing(1),
    },
  },
});

export const uiConfig = {
  name: 'UsersPage',
  state: () => ({
    loaded: false,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledUsersPage));
